// extracted by mini-css-extract-plugin
export var box = "_71-1";
export var checkboxRow = "_71-8";
export var checked = "_71-2";
export var descriptionSpacer = "_71-a";
export var disabled = "_71-3";
export var icon = "_71-6";
export var input = "_71-0";
export var labelSpacer = "_71-9";
export var medium = "_71-5";
export var small = "_71-4";
export var text = "_71-7";